<!--<div class="form-main">-->
<!--    <ul>-->
<!--        <li *ngFor="let item of textualContent; let n = index">-->
<!--            &lt;!&ndash;      <fa-icon size="lg" [ngClass]="{large: n === 0}" class="{{item.class}}" [icon]="item.icon"></fa-icon>&ndash;&gt;-->
<!--            <fa-icon [ngClass]="{lowOpacity: item?.legacy === true}" size="lg" class="{{item.class}}" [icon]="item.icon"></fa-icon>-->
<!--            <mat-label [ngClass]="{lowOpacity: item?.legacy === true}" (click)="download(item.type)" class="itemText">-->
<!--                <span [ngClass]="{large: n < 1}" class="downloadable ">{{item.h1}}</span>-->
<!--                <span *ngIf="item.extra" class="downloadable "></span>-->
<!--                <span *ngIf="item.extra" (click)="download(item.extra.type)" class="downloadable ">{{item.extra.h2}}</span>-->
<!--                <br/>-->
<!--                <div class="os-info-text">{{item.h2}}</div>-->
<!--            </mat-label>-->
<!--            <div *ngIf="n === 0">-->
<!--                <br/>-->
<!--                <br/>-->
<!--                <br/>-->
<!--                <br/>-->
<!--                <div fxLayout="column" fxLayoutAlign="center center" class="lowOpacity" style="position: relative; left: -100px">-->
<!--                    Legacy / previous versions-->
<!--                    <mat-icon>keyboard_arrow_down</mat-icon>-->
<!--                </div>-->
<!--            </div>-->
<!--    </ul>-->
<!--    <br/>-->
<!--    <br/>-->
<!--    <br/>-->
<!--</div>-->
<div class="form-main">
    <!-- Hero Section -->
    <div class="hero-section">
        <div class="hero-icon">
            <mat-icon>web</mat-icon>
        </div>
        <h1 class="hero-title">SignStudio</h1>
        <p class="hero-subtitle">Digital Signage & Touch Editor</p>

        <!-- Feature Badges -->
        <div class="feature-badges">
            <div class="feature-badge">
                <mat-icon>cloud</mat-icon>
                <span>Cloud-Based</span>
            </div>
            <div class="feature-badge">
                <mat-icon>devices</mat-icon>
                <span>Cross-Platform</span>
            </div>
            <div class="feature-badge">
                <mat-icon>offline_bolt</mat-icon>
                <span>PWA Enabled</span>
            </div>
        </div>
    </div>

    <!-- Login Button -->
    <div class="login-section">
        <button mat-raised-button color="warn" class="downloadMainBut" (click)="download('studio_web')">
            <mat-icon>login</mat-icon>
            <span>Login to SignStudio</span>
        </button>

        <div class="info-card">
            <mat-icon>info</mat-icon>
            <p>
                Web-based Digital Signage & touch editor. Install SignStudio directly onto your Desktop or Mobile device using the progressive web app (PWA).
            </p>
        </div>

        <!-- Toggle Legacy Button -->
        <button mat-stroked-button class="legacy-toggle-btn" (click)="toggleLegacyDownloads()">
            <mat-icon>{{ showLegacyDownloads ? 'expand_less' : 'expand_more' }}</mat-icon>
            <span>{{ showLegacyDownloads ? 'Hide' : 'Show' }} Legacy Versions</span>
        </button>
    </div>

    <!-- Legacy Downloads Section -->
    @if (showLegacyDownloads) {
    <div class="legacy-section">
        <div class="legacy-header">
            <mat-icon>history</mat-icon>
            <h3>Legacy Versions</h3>
            <span class="deprecated-badge">Deprecated</span>
        </div>

        <p class="legacy-description">Previous versions of SignageStudio AIR</p>

        <div class="legacy-downloads">
            <div class="legacy-card" (click)="download('studio_exe')">
                <mat-icon class="platform-icon">laptop_windows</mat-icon>
                <div class="legacy-content">
                    <h4>LegacyStudio Desktop</h4>
                    <p>Windows (32/64 bit) .exe</p>
                </div>
                <mat-icon class="download-icon">download</mat-icon>
            </div>

            <div class="legacy-card" (click)="download('studio_dmg')">
                <mat-icon class="platform-icon">laptop_mac</mat-icon>
                <div class="legacy-content">
                    <h4>LegacyStudio Desktop</h4>
                    <p>macOS .dmg</p>
                </div>
                <mat-icon class="download-icon">download</mat-icon>
            </div>

            <div class="legacy-card" (click)="download('studio_air')">
                <mat-icon class="platform-icon">extension</mat-icon>
                <div class="legacy-content">
                    <h4>Adobe Runtime AIR</h4>
                    <p>Cross-platform .air</p>
                </div>
                <mat-icon class="download-icon">download</mat-icon>
            </div>
        </div>
    </div>
    }
</div>

